import { UIComponentViewImpl } from '../../uicomponentview';
import { UIDataModel, UIComponentHandler } from '../../uicomponent';
import * as React from 'react';
import { ToneRowComponentProps, ToneRowComponentHandler, ToneRowComponentState, ToneRowOptionsPrivilage } from './tonerowcomponent';
import { EnglishToneRowCSSStyle } from './englishtonerowcss';
import { PlayerComponent } from '../../player/playercomponent';
import { PlayerComponentCSSStyle } from '../../player/playercss';
import { ImageLoaderComponent } from '../../imageloader/imageloadercomponent';
import { ImageLoaderCSSStyle } from '../../imageloader/imageloadercss';
import { ToneRowImageLoaderCSSStyleImpl } from './tonerowimageloadercss';
import { ButtonComponent } from '../../button/buttoncomponent';
import { ToneCardButtonCSSStyleImpl } from '../../../components/home/featuredcategory/viewmodel/tonecard/tonecardbuttoncssstyle';
import { PopUpWrapperComponent } from '../../../components/popup/popupwrappercomponent';
import { BuyToneComponent } from '../../../components/popup/buytone/buytonecomponent';
import { DropDownRowViewModelImpl, DropdownRowViewModelHandler } from '../../dropdownlist/dropdownrow/dropdownviewmodel';
import { DropDownListComponent } from '../../dropdownlist/dropdownlistcomponent';
import { GiftAFriendComponent } from '../../../components/popup/giftafriend/giftafriendcomponent';
import { ShareToneComponent } from '../../../components/popup/sharetone/sharetonecomponent';
import { TellAFriendComponent } from '../../../components/popup/tellafriend/tellafriendcomponent';
import { ToneRowPlayerComponentCSSStyleImpl } from './tonerowplayercss';
import { ToneOptionsType } from '../../../components/popup/tonedetailspopup/tonedetailspopupcomponent';
import { PlayerHandler } from '../../../../utils/player/playmanager';
import { Strings } from '../../../../utils/resources/strings';
import { DropDownDtoImpl, DropDownDto } from '../../../../core/dto/dropdown/dropdowndto';
import { BaseContext } from '../../../../utils/basecontext';
import { ToneStatus } from './tonestatus';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { DropDownListCSSStyleImpl } from '../../dropdownlist/dropdownlistcss';

export class ToneRowViewImpl extends UIComponentViewImpl<UIDataModel> implements PlayerHandler, DropdownRowViewModelHandler
{
   private playerComponent: PlayerComponent | null;
   private initialStateOfTonePlaying: boolean;
   private imageLoaderCSSStyle: ImageLoaderCSSStyle;
   private playerCSSStyle: PlayerComponentCSSStyle;
   private popUpComponent: PopUpWrapperComponent;
   private listViewModel: DropDownRowViewModelImpl;

    constructor(toneRowOptionsPrivilage: ToneRowOptionsPrivilage, context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.imageLoaderCSSStyle = new ToneRowImageLoaderCSSStyleImpl(context);
        this.playerCSSStyle = new ToneRowPlayerComponentCSSStyleImpl(context);
        this.listViewModel = new DropDownRowViewModelImpl(false, context, this);
        this.listViewModel.setListDatas(this.getListOfDropDown(toneRowOptionsPrivilage, context));
    }

    bindHandlers()
    {
        this.onRowClick = this.onRowClick.bind(this);
        this.hideMoreActions = this.hideMoreActions.bind(this);
        this.showMoreActions = this.showMoreActions.bind(this);
        this.onBuyToneClicked = this.onBuyToneClicked.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.onPlayClicked = this.onPlayClicked.bind(this);
        this.onSettingsClicked = this.onSettingsClicked.bind(this);
        this.onTuneSettingsAdded = this.onTuneSettingsAdded.bind(this);
        this.onStopClicked = this.onStopClicked.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
    }
    
    draw(props: ToneRowComponentProps, state: ToneRowComponentState, cssStyle:EnglishToneRowCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
           
            <tr style={cssStyle.getWrapperCSSStyle()}>
             
                <td id="tone-image" style={cssStyle.getToneImageDivCSSStyle(props.toneRowOptionsPrivilage.isPreview())}>
                    <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.toneDto.getImgPath()} imageLoaderCSSStyle={this.imageLoaderCSSStyle} context={props.context}/>
                </td>   
                <td style={cssStyle.getToneDetailsDivCSSStyle(props.toneRowOptionsPrivilage.isPreview())} onClick={this.onRowClick}>
                        <div style={cssStyle.getToneNameCSSStyle()}>
                                {props.toneDto.getToneName()}
                        </div>
                        <div style={cssStyle.getArtistNameDivCSSStyle()}>
                            {props.toneDto.getArtistName()}
                        </div>
                </td>
                {props.toneRowOptionsPrivilage.isBuy() && <td style={cssStyle.getBuyNowCSSStyle()} onClick={this.onBuyToneClicked}>
                    <ButtonComponent label={props.context.getResources().getString(Strings.buy_now)} style={new ToneCardButtonCSSStyleImpl(props.context)} onClick={() =>{}} context={props.context}/>
                </td>}
                {props.toneDto.getStatus() !== ToneStatus.ACCEPTED && 
                    <td style={cssStyle.getStatusDivCSSStyle()}>
                    <img width='24px' height='24px' src={props.context.getResources().getImage(this.getStatusImg(props.toneDto.getStatus()))}/>
                    <label style={cssStyle.getStatusTextCSSStyle(props.toneDto.getStatus())}>{props.toneDto.getStatus()}</label>
                </td>}
                {props.toneRowOptionsPrivilage.isSettings() && props.toneDto.getStatus() === ToneStatus.ACCEPTED && 
                <td style={cssStyle.getSettingDivCSSStyle()} >
                    <img width='24px' height='24px' onClick={this.onSettingsClicked} src={props.context.getResources().getImage('Settings.svg')}/>
                </td>}
                {props.toneRowOptionsPrivilage.isPlay() && <td style={cssStyle.getPlayDivCSSStyle()}>
                    <PlayerComponent playIconName={"play_pink.svg"} pauseIconName={"pause_pink.svg"} playerCSSStyle={this.playerCSSStyle} isPlaying={this.initialStateOfTonePlaying} onPlayClicked={this.onPlayClicked} onStopClicked={this.onStopClicked} ref={item=>this.playerComponent=item} context={this.getUIProps().context}/> 
                </td>}
                {props.toneRowOptionsPrivilage.isDelete() && <td style={cssStyle.getDeleteDivCSSStyle(props.toneDto.getStatus() === ToneStatus.ACCEPTED)} onClick={this.onDeleteClicked}>
                    <img width='24px' height='24px'  src={props.context.getResources().getImage('delete_trash.svg')}/>
                </td>}
                {props.toneRowOptionsPrivilage.isLike() && <td style={cssStyle.getLikeCSSStyle()}>
                    <img width='24px' height='24px'  src={props.context.getResources().getImage('heart.svg')}/>
                </td>}
                {props.toneRowOptionsPrivilage.isAction() && <td style={cssStyle.getActionDivCSSStyle()} onClick={this.showMoreActions}>
                     <img src={props.context.getResources().getImage('menu.svg')} width='24px' height='24px' />
                     {
                       state.isShowHideMoreActions && <div style={cssStyle.getMyAccountDropDownSSStyle()} onMouseLeave={this.hideMoreActions}>
                            <DropDownListComponent cssStyle={new DropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={props.context}/>
                    </div>}
                </td>}
                <PopUpWrapperComponent ref={(item: any) => this.popUpComponent = item} context={props.context}/>
            </tr>          
        );
    }

    
    onPlayComplete(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayComplete();
    }
   
    onPlayStop(): void 
    {
        this.initialStateOfTonePlaying = false;
        this.playerComponent !== null && this.playerComponent.onPlayStop();
    }

    onRowSelected(dropDownDto: DropDownDto): void 
    {
        if(dropDownDto.getId() === this.getUIProps().context.getResources().getString(Strings.gift_a_friend))
        {
            this.popUpComponent.setShowWindow(true,
                <GiftAFriendComponent showPopup={()=>''} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneRowComponentProps).toneDto} context={this.getUIProps().context}/>);
        }
        else if(dropDownDto.getId() === this.getUIProps().context.getResources().getString(Strings.wishlist))
        {
            (this.getUIComponentHandler() as ToneRowComponentHandler).addToWishlist();
        }
        else if(dropDownDto.getId() === this.getUIProps().context.getResources().getString(Strings.shareatone))
        {
            this.popUpComponent.setShowWindow(true,
                <ShareToneComponent  toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneRowComponentProps).toneDto} context={this.getUIProps().context}/>);
        }
        else if(dropDownDto.getId() === this.getUIProps().context.getResources().getString(Strings.tellafriend))
        {
            this.popUpComponent.setShowWindow(true,
                <TellAFriendComponent showPopup={()=>''} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneRowComponentProps).toneDto} context={this.getUIProps().context}/>);
        }
    }

    private onSettingsClicked()
    {
        this.popUpComponent.setWidth("1032px");
        // this.popUpComponent.setShowWindow(true,
        //     <TuneSettingsComponent onTuneSettingsAdd={this.onTuneSettingsAdded} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneRowComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

    private onTuneSettingsAdded(toneDto: ToneDto)
    {
        (this.getUIProps() as ToneRowComponentProps).onTuneSettingsAdded(toneDto);

        this.closePopup();
    }

    private showMoreActions() 
    {
        (this.getUIComponentHandler() as ToneRowComponentHandler).showHideMoreActions(true);
    }
    
    private hideMoreActions()
    {
        (this.getUIComponentHandler() as ToneRowComponentHandler).showHideMoreActions(false);
    }

    private onBuyToneClicked(): void 
    {
        this.popUpComponent.setShowWindow(true,
        <BuyToneComponent showPopupOption={()=>''} getPopupWrapper={()=>""}  showPopup={()=>""} toneOptionsType={ToneOptionsType.TONE} closePopup={this.closePopup} toneDto={(this.getUIProps() as ToneRowComponentProps).toneDto} context={this.getUIProps().context}/>);
    }

    private closePopup()
    {
        this.popUpComponent.setShowWindow(false, <></>);
    }

    private onRowClick()
    {
        if((this.getUIProps() as ToneRowComponentProps).toneRowOptionsPrivilage.isPreview())
        {
            (this.getUIComponentHandler() as ToneRowComponentHandler).onRowSelected();
        }
    }

    private onPlayClicked(): void
    {
        this.initialStateOfTonePlaying = true;
        this.getContext().getPlayerManager()
                    .startPlay((this.getUIProps() as ToneRowComponentProps).toneDto.getToneUrl(), this);
    }

    private onDeleteClicked()
    {
        if((this.getUIProps() as ToneRowComponentProps).toneDto.getStatus() === ToneStatus.ACCEPTED)
        {
            (this.getUIComponentHandler() as ToneRowComponentHandler).onDeleteClicked();
        }
    }

    private onStopClicked(): void
    {
        this.initialStateOfTonePlaying = false;

        this.getContext().getPlayerManager().stopPlay();
    }

    private getListOfDropDown(toneOptionsPrivilage: ToneRowOptionsPrivilage, context: BaseContext)
    {  
        let dropDownList = [];

        if(toneOptionsPrivilage.isGift())
        {
            let dropDown1 = new DropDownDtoImpl();
            dropDown1.setId(context.getResources().getString(Strings.gift_a_friend));
            dropDown1.setIconName("");
            dropDown1.setTitle(context.getResources().getString(Strings.gift));

            dropDownList.push(dropDown1);
        }

       if(toneOptionsPrivilage.isAddWishlist())
       {
           let dropDown2 = new DropDownDtoImpl();
           dropDown2.setId(context.getResources().getString(Strings.wishlist));
           dropDown2.setIconName("");
           dropDown2.setTitle(context.getResources().getString(Strings.wishlist));

           dropDownList.push(dropDown2);
       }
   
       if(toneOptionsPrivilage.isShare())
       {
           let dropDown2 = new DropDownDtoImpl();
           dropDown2.setId(context.getResources().getString(Strings.share));
           dropDown2.setIconName("");
           dropDown2.setTitle(context.getResources().getString(Strings.share));

           dropDownList.push(dropDown2);
       }

       if(toneOptionsPrivilage.isTellAFriend())
       {
           let dropDown3 = new DropDownDtoImpl();
           dropDown3.setId(context.getResources().getString(Strings.tellafriend));
           dropDown3.setIconName("");
           dropDown3.setTitle(context.getResources().getString(Strings.tellafriend));

           dropDownList.push(dropDown3);
       }

        return dropDownList;
    }

    private getStatusImg(status: ToneStatus)
    {
        if(status === ToneStatus.REJECTED)
        {
            return "rejected.svg";
        }
        else if(status === ToneStatus.PENDING)
        {
            return  "pending.svg";
        }
        else
        {
           return "inactive.svg";
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowview.tsx